<script setup lang="ts">
import { pinLoginAction, logoutAction } from '@/actions/core';
import UiActionTouchButton from '@/components/core/UiActionTouchButton.vue';
import { useSessionStore } from '@/stores/session';
import { useI18n } from 'vue-i18n';
import { computed } from 'vue';
import { storeToRefs } from 'pinia';

const { t } = useI18n();

const sessionStore = useSessionStore();
const { displayEmployee, session, shouldBypassPin } = storeToRefs(sessionStore);

const roleDisplayName = computed(() => {
  if (!displayEmployee.value?.role?.slug) {
    return t('roles.unknown');
  }

  // Use the role slug to get the translated role name
  return t(`roles.${displayEmployee.value.role.slug}`, displayEmployee.value.role.name);
});
</script>

<template>
  <div class="max-desktop:landscape:flex-col flex items-center gap-2">
    <div v-if="displayEmployee" class="max-desktop:landscape:ui-sideways mx-4 text-right">
      <p class="text-lg/tight font-semibold">{{ displayEmployee.fullName }}</p>
      <p class="text-app-base italic">{{ roleDisplayName }}</p>
    </div>

    <!-- Show PIN button if session exists and should not bypass PIN (not admin on own account) -->
    <UiActionTouchButton v-if="session && !shouldBypassPin" :action="pinLoginAction()" />
    <UiActionTouchButton v-if="session" :action="logoutAction()" />
  </div>
</template>
